// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1uiq5","consentsList":"PatientConsents_consentsList__2zj1j","consentsListEmpty":"PatientConsents_consentsListEmpty__TSLNJ"};